/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { SvgIcon } from '@mui/material';

export function CheckMarkIcon(props: React.ComponentProps<typeof SvgIcon>) {
  return (
    <SvgIcon {...props}>
      <path d="M17.4965072,10.2730564 L12.31997,15.4495936 C11.5384301,16.2298021 10.2735869,16.2298021 9.49204692,15.4495936 L7.13943856,13.0969852 C6.62018715,12.5777338 6.62018715,11.7349488 7.13943856,11.214366 C7.6600214,10.6951146 8.50280639,10.6951146 9.02205781,11.214366 L9.96203602,12.1543442 C10.2161314,12.4084396 10.5476225,12.5385116 10.8811107,12.5445601 C11.230863,12.5509036 11.5828119,12.4208316 11.8499809,12.1543442 L15.613888,8.39043712 C16.1331394,7.86985429 16.9772558,7.86985429 17.4965072,8.39043712 C18.0170901,8.90968854 18.0170901,9.75380495 17.4965072,10.2730564 Z" />
    </SvgIcon>
  );
}
